import gql from 'graphql-tag'

export const SEND_CHANGE_SURGERY_EMAIL = gql`
mutation SendChangeSurgeryEmail(
    $date: String!
) {
    sendChangeSurgeryEmail(date: $date)
}
`



// WEBPACK FOOTER //
// ./src/mutations/SEND_CHANGE_SURGERY_EMAIL.ts